import axios from "axios";

// export const FRAPPE_BASE = "http://35.78.223.152:8000";
export const FRAPPE_BASE = "http://35.78.223.152:8000";

export const frappe = axios.create({
    baseURL: FRAPPE_BASE,
    withCredentials: true, // IMPORTANT: stores/uses sid cookie
    headers: {
        "Accept": "application/json"
    }
});
